export const UI_FILE_UPLOADER_LOCALE_ES = {
  UPLOADER: {
    DROPZONE: {
      LABEL: {
        PLURAL: 'Arrastra los archivos aquí para subirlos',
        SINGULAR: 'Arrastra el archivo aquí para subirlo',
      },
      DESCRIPTION: 'o haz clic para seleccionar desde',
      BROWSE: 'tu dispositivo.',
    },
    ACTION: {
      ADD: 'Añadir',
      UPLOAD: 'Subir',
      CLEAR: 'Limpiar',
    },
    ACCESSIBILITY: {
      ADD_FILES_SR_ONLY: 'Añadir archivos',
      UPLOAD_ALL_SR_ONLY: 'Subir todos',
      CLEAR_ALL_SR_ONLY: 'Limpiar todos',
      SINGLE_UPLOAD_SR_ONLY: 'Subir archivo',
      SINGLE_REMOVE_SR_ONLY: 'Eliminar archivo',
      IMAGE_PREVIEW_ALT: 'Vista previa de imagen',
    },
  },
};

export const UI_FILE_UPLOADER_LOCALE_EN = {
  UPLOADER: {
    DROPZONE: {
      LABEL: {
        PLURAL: 'Drag and drop files here to upload',
        SINGULAR: 'Drag and drop the file here to upload',
      },
      DESCRIPTION: 'or click to select from',
      BROWSE: 'your device.',
    },
    ACTION: {
      ADD: 'Add',
      UPLOAD: 'Upload',
      CLEAR: 'Clear',
    },
    ACCESSIBILITY: {
      ADD_FILES_SR_ONLY: 'Add files',
      UPLOAD_ALL_SR_ONLY: 'Upload all',
      CLEAR_ALL_SR_ONLY: 'Clear all',
      SINGLE_UPLOAD_SR_ONLY: 'Single upload',
      SINGLE_REMOVE_SR_ONLY: 'Single remove',
      IMAGE_PREVIEW_ALT: 'Image preview',
    },
  },
};
